export default "__VITE_ASSET__CjHZ78nK__"